import React from 'react';
import styled from 'styled-components';
import Heading from 'components/atoms/Heading/Heading';
import Paragraph from 'components/atoms/Paragraph/Paragraph';
import { TextField, Button } from '@mui/material';
import { theme } from 'theme/MainTheme';

const SettingsWrapper = styled.div`
  width: 100%;
  height: calc(100vh - 70px);
  padding: 30px;
`;

const StyledParagraph = styled(Paragraph)`
  font-weight: ${theme.bold};
  padding-top: 2rem;
  color: ${theme.primary};
`;

const SettingRow = styled.div`
  padding-bottom: 2rem;
`;

const SettingGroup = styled.div`
  padding-bottom: 2rem;
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: end;
`;

const AdminSettings = () => (
  <SettingsWrapper>
    <Heading>Ustawienia domyślne</Heading>
    <SettingGroup>
      <StyledParagraph>Adresy mailowe</StyledParagraph>
      <SettingRow>
        <div>Formularz kontaktowy - aktualizacja danych</div>
        <TextField
          id="outlined-multiline-flexible"
          multiline
          maxRows={4}
          sx={{ width: '200px', paddingTop: '10px' }}
        />
      </SettingRow>
      <SettingRow>
        <div>Formularz kontaktowy - wynagrodzenia</div>
        <TextField
          id="outlined-multiline-flexible"
          multiline
          maxRows={4}
          sx={{ width: '200px', paddingTop: '10px' }}
        />
      </SettingRow>
    </SettingGroup>
    <ButtonWrapper>
      <Button
        type="button"
        variant="contained"
        sx={{ backgroundColor: theme.primary, mb: 1, mt: 1.5, width: '150px' }}
      >
        Zapisz
      </Button>
    </ButtonWrapper>
  </SettingsWrapper>
);

export default AdminSettings;
